<div class="row wrapper">
  <div class="col-md-5 reportsForm">
    <input [(ngModel)]="startDt" [max]="maxDate" name="startDate" (keyup)="changeEndDate()" (keyup)="sendDates()" class="form-control form-control-lg" [readonly]="0" type="datetime-local" placeholder="Date Time" #startDate="ngModel" required />
    @if (!startDt) {
<div>
      <small class="text-danger">Please select a valid start date</small>
    </div>
}
  </div>
  <div class="col-sm-1 mt-0 pt-2 d-none d-sm-inline-block text-center">To</div>
  <!-- to label for mobile -->
  <div class="col-sm-1 mt-0 mb-3 d-inline-block d-sm-none pt-0 text-center">To</div>
  <div class="col-md-5 reportsForm">
    <input [(ngModel)]="endDt" [min]="minDate" [max]="maxDate" name="endDate" (keyup)="sendDates()" (keyup)="saveEndDate()" class="form-control form-control-lg" [readonly]="0" type="datetime-local" placeholder="Date Time" #endDate="ngModel" required />
    @if (!endDt) {
<div>
      <small class="text-danger">Please select a valid end date</small>
    </div>
}
  </div>
</div>
